import './DropdownCategory.89c17a529cbb84c0e817e5b248f81c22.css';
export default {"category":"_category_1fsw1_1","small":"_small_1fsw1_1"};